
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    SB: "SB",
    AA: "AA",
    OP: "OP",
    MA: "MA",
    WS: "WS"
};
